import React, { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import FormInput from '../input/FormInput';

function Reference({ name, reference, defaultToDefault, ...props }) {
    const {
        setValue,
        clearErrors,
        trigger,
        getValues,
        selectedValues,
        formState: { defaultValues },
        // wrap
    } = useFormContext();
    const { referenceField, referenceKey, alwaysOverwrite } = reference;
    const hasUpdated = useRef(false);

    useEffect(() => {
        const referenceFieldValue = getValues(referenceField);
        const referenceFieldDefaultValue = defaultValues?.[referenceField];

        // Skip all updates if the reference field is the same as the default field when alwaysOverwrite is enabled
        if (alwaysOverwrite && !hasUpdated.current && referenceFieldValue === referenceFieldDefaultValue) {
            return;
        }

        const value = selectedValues[referenceField];
        let referenceValue = value?.[referenceKey];
        const currentVal = getValues(name);

        // calling setValue does not call onChange
        // validation methods need to manually be called
        clearErrors([name]);
        if (props.props.valueAsNumber && typeof referenceValue === 'string') {
            referenceValue = parseFloat(referenceValue);
        }

        if (defaultToDefault && !alwaysOverwrite) {
            // Only use the reference value if the default value has been changed
            const defaultValue = defaultValues?.[name];
            const newValue = defaultValue && defaultValue === currentVal ? defaultValue : referenceValue;
            setValue(name, newValue, { shouldDirty: true });
        } else {
            setValue(name, referenceValue ?? currentVal, { shouldDirty: true });
        }
        trigger([name]);
        hasUpdated.current = true;
    }, [selectedValues[referenceField]]);

    return <FormInput name={name} {...props} />;
}

export default Reference;
